export default "__VITE_ASSET__1hu$3aNX__"